<template>
  <q-layout view="hHh LpR fFf" class="bg-grey-1">
    <app-header @toggle="leftDrawerOpen = !leftDrawerOpen"/>

    <q-drawer
      v-if="isGranted('VIEW_CLIENTS')"
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      content-class="bg-white"
      :width="300"
    >
      <q-scroll-area class="fit">
        <slot>
          <side-bar />
        </slot>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>

    <Drawer />

    <q-footer class="bg-white q-py-xs q-px-sm text-right" bordered>
      <privacy-policy-link />
    </q-footer>
  </q-layout>
</template>

<style lang="scss">
    .YL {
        &__toolbar-input-container {
            min-width: 100px;
            width: 55%
        }
        &__toolbar-input-btn {
            border-radius: 0;
            border-style: solid;
            border-width: 1px 1px 1px 0;
            border-color: rgba(0, 0, 0, .24);
            max-width: 60px;
            width: 100%;
        }
    }
</style>

<script>
import isGranted from '@/auth/isGranted';
import PrivacyPolicyLink from '@/PrivacyPolicyLink.vue';
import Header from './Header.vue';
import SideBar from './SideBar.vue';
import Drawer from './Drawer.vue';

export default {
  components: {
    PrivacyPolicyLink,
    'app-header': Header,
    'side-bar': SideBar,
    Drawer,
  },
  name: 'App',
  data() {
    return {
      leftDrawerOpen: false,
    };
  },
  methods: { isGranted },
};
</script>
